import { backToTopLauncher } from '../../exports/backToTopLauncher.jsx';

export function loadWidgetButtons() {
    // Pin Back to Top button to bottom, since we don't show chat widget
    backToTopLauncher({ showChatWidget: false });
}
